export const premiumPricingTableModule = {
  name: 'Premium Pricing Table',
};
